// @ts-strict-ignore
import React, { useEffect } from 'react'
import { Keyboard, View } from 'react-native'
import { useDispatch, useSelector } from 'APP/Hooks/redux'
import styled from 'styled-components/native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { useForm } from 'react-hook-form'

import ControllerInput from 'APP/Components/ControllerFields/ControllerInput'
import PatientActions from 'APP/Redux/PatientRedux'
import { patientState } from 'APP/Sagas/PatientSagas'

import I18n from 'APP/I18n'
import Button from 'APP/Converse/Button'
import LogoHeader from 'APP/Components/LogoHeader'
import Card from 'APP/Converse/Card'
import { Images } from 'APP/Themes'

const Container = styled(SafeAreaView)`
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
  background-color: ${({ theme }) => theme.colors.background};
`

const ContentCard = styled(Card)`
  max-width: 550px;
  width: 100%;
  align-items: start;
  gap: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
`

interface FormProps {
  password: string
}

const VerifyNewEmailScreen = () => {
  const { changeEmailToken, requestRunning } = useSelector(patientState)
  const dispatch = useDispatch()
  const {
    control,
    handleSubmit,
    setValue,
    formState: { isValid },
  } = useForm({
    mode: 'all',
    defaultValues: {
      newEmail: '',
      oldEmail: '',
      password: '',
    },
  })
  const onSubmit = (values: FormProps) => {
    dispatch(PatientActions.changeEmailRequest(values.password))
  }

  useEffect(() => {
    setValue('oldEmail', changeEmailToken.old_email)
    setValue('newEmail', changeEmailToken.new_email)
  }, [])

  return (
    <Container>
      <ContentCard>
        <LogoHeader
          source={Images.logoBlue}
          title={I18n.t('VerifyNewEmailScreen.confirm.title')}
          titleVariant="h3"
        />
        <View>
          <ControllerInput
            disabled
            control={control}
            name="oldEmail"
            label={I18n.t('VerifyNewEmailScreen.confirm.currentEmail')}
          />
          <ControllerInput
            disabled
            control={control}
            name="newEmail"
            label={I18n.t('VerifyNewEmailScreen.confirm.newEmail')}
          />
          <ControllerInput
            control={control}
            isSecureEntry
            name="password"
            testID="CHANGE_PASSWORD_INPUT"
            label={I18n.t('VerifyNewEmailScreen.confirm.password')}
            rules={{
              required: I18n.t('VerifyNewEmailScreen.confirm.passwordRequired'),
            }}
          />
        </View>
        <Button
          onPress={() => {
            Keyboard.dismiss()
            handleSubmit(onSubmit)()
          }}
          widthVariant="full"
          isLoading={requestRunning}
          analyticsName="Submit VerifyNewEmailScreen"
          disabled={!isValid || requestRunning}
          title={I18n.t('VerifyNewEmailScreen.confirm.cta')}
          testID="CHANGE_EMAIL_BTN"
        />
      </ContentCard>
    </Container>
  )
}

export default VerifyNewEmailScreen
